import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "aiRoleSelectorContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "loadingState"
};
const _hoisted_3 = {
  class: "loadingMessage"
};
const _hoisted_4 = {
  class: "loadingSubMessage"
};
const _hoisted_5 = {
  key: 1,
  class: "errorState"
};
const _hoisted_6 = {
  class: "errorTitle"
};
const _hoisted_7 = {
  class: "errorSubtitle"
};
const _hoisted_8 = {
  class: "errorActions"
};
const _hoisted_9 = {
  key: 2,
  class: "loadedState"
};
const _hoisted_10 = {
  class: "titleText"
};
const _hoisted_11 = {
  class: "subtitleText"
};
const _hoisted_12 = {
  class: "helperText"
};
const _hoisted_13 = {
  class: "rolesSection"
};
const _hoisted_14 = {
  key: 0,
  class: "labelLine labelLineDark"
};
const _hoisted_15 = {
  key: 1,
  class: "noRolesDetected"
};
const _hoisted_16 = {
  class: "noRolesText"
};
const _hoisted_17 = {
  class: "noRolesHint"
};
const _hoisted_18 = {
  key: 2,
  class: "rolesList"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  key: 0,
  class: "roleCheck"
};
const _hoisted_21 = {
  class: "roleIconWrap"
};
const _hoisted_22 = {
  class: "roleBody"
};
const _hoisted_23 = {
  class: "roleTitle"
};
const _hoisted_24 = {
  class: "roleDesc"
};
const _hoisted_25 = {
  key: 0,
  class: "customRolesSection"
};
const _hoisted_26 = {
  class: "labelLine"
};
const _hoisted_27 = {
  class: "rolesList"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 0,
  class: "roleCheck"
};
const _hoisted_30 = {
  class: "roleIconWrap"
};
const _hoisted_31 = {
  class: "roleBody"
};
const _hoisted_32 = {
  class: "roleTitle"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  class: "addCustomRoleSection"
};
const _hoisted_35 = {
  class: "labelLine"
};
const _hoisted_36 = {
  class: "addCustomRoleRow"
};
const _hoisted_37 = {
  key: 3,
  class: "bottomLineButton"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader");
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loader, {
    "spinner-size": "spinnersLarge"
  }), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.loading')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.loadingSubtitle')), 1), _createVNode(_component_el_skeleton, {
    rows: 5,
    animated: "",
    class: "loadingSkeleton"
  })])) : _ctx.errorState ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_icon, {
    icon: "alert-circle-outline",
    size: "huge",
    color: "danger"
  }), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.errorTitle')), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.error')), 1), _createElementVNode("div", _hoisted_8, [_createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.onBack
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "arrow-left"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.back')), 1)]),
    _: 1
  }, 8, ["onAction"]), _createVNode(_component_standard_button, {
    onAction: _ctx.analyze
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "refresh"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.retry')), 1)]),
    _: 1
  }, 8, ["onAction"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.title')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.subtitle')), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.helperText')), 1), _createElementVNode("div", _hoisted_13, [_ctx.detectedRoles.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.detectedRolesLabel')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_icon, {
    icon: "information-outline",
    color: "warning"
  }), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.noRolesDetected')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.noRolesDetectedHint')), 1)])])), _ctx.detectedRoles.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detectedRoles, role => {
    return _openBlock(), _createElementBlock("div", {
      key: role.id,
      class: _normalizeClass(["roleItem", {
        'roleItemSelected': _ctx.isSelected(role.id)
      }]),
      onClick: $event => _ctx.toggleRole(role)
    }, [_ctx.isSelected(role.id) ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_icon, {
      icon: "check"
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_createVNode(_component_icon, {
      icon: "account-outline",
      size: "large",
      color: _ctx.isSelected(role.id) ? 'primary' : 'light2'
    }, null, 8, ["color"])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(role.title), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(role.description), 1)])], 10, _hoisted_19);
  }), 128))])) : _createCommentVNode("", true)]), _ctx.customRoles.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.customRolesLabel')), 1), _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customRoles, role => {
    return _openBlock(), _createElementBlock("div", {
      key: role.id,
      class: _normalizeClass(["roleItem customRoleItem", {
        'roleItemSelected': _ctx.isSelected(role.id)
      }]),
      onClick: $event => _ctx.toggleRole(role)
    }, [_ctx.isSelected(role.id) ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_icon, {
      icon: "check"
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_30, [_createVNode(_component_icon, {
      icon: "account-plus-outline",
      size: "large",
      color: _ctx.isSelected(role.id) ? 'primary' : 'light2'
    }, null, 8, ["color"])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createTextVNode(_toDisplayString(role.title) + " ", 1), _createVNode(_component_el_tag, {
      size: "small",
      type: "info",
      effect: "plain",
      class: "customBadge"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.customBadge')), 1)]),
      _: 1
    })])]), _createElementVNode("div", {
      class: "roleRemove",
      onClick: _withModifiers($event => _ctx.removeCustomRole(role.id), ["stop"])
    }, [_createVNode(_component_icon, {
      icon: "close",
      size: "small"
    })], 8, _hoisted_33)], 10, _hoisted_28);
  }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.addCustomLabel')), 1), _createElementVNode("div", _hoisted_36, [_createVNode(_component_el_input, {
    modelValue: _ctx.customRoleInput,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.customRoleInput = $event),
    size: "large",
    placeholder: _ctx.$t('aiSpeachGenerator.roleBased.roleSelector.addCustomPlaceholder'),
    onKeyup: _withKeys(_ctx.addCustomRole, ["enter"]),
    clearable: ""
  }, null, 8, ["modelValue", "placeholder", "onKeyup"]), _createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.addCustomRole,
    disabled: !_ctx.customRoleInput.trim()
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "plus"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.roleSelector.addCustomButton')), 1)]),
    _: 1
  }, 8, ["onAction", "disabled"])])])])), !_ctx.loading && !_ctx.errorState ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.onBack
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "arrow-left"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.back')), 1)]),
    _: 1
  }, 8, ["onAction"]), _createVNode(_component_standard_button, {
    disabled: _ctx.selectedRoleIds.length === 0,
    onAction: _ctx.onValidate
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.continueButtonLabel) + " ", 1), _createVNode(_component_icon, {
      icon: "arrow-right"
    })]),
    _: 1
  }, 8, ["disabled", "onAction"])])) : _createCommentVNode("", true)]);
}